<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">岗位名称</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="form.name" placeholder="请输入名称" />
            </div>
          </div>
        </div>
      </div>

      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">岗位描述</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                placeholder="请输入岗位工作性质、内容、职责等描述"
                rows="8"
                v-model="form.description"
                maxlength="200"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{form.description?form.description.length:0}}</span>/200
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/account/role",
      form: {},
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form;
      if (!main.name) {
        me.$weui.topTips("请填写名称", 2000);
      } else if (!main.description) {
        me.$weui.topTips("请填写描述", 2000);
      } else {
        if (main.id) {
          me.f_update();
        } else {
          me.f_save();
        }
      }
    },
  },
};
</script>